var _defs, _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGDoc",
    width: 13,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    className: "bi bi-chevron-left me-2",
    viewBox: "0 0 13 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Generated with Avocode.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Rechteck 496"), /*#__PURE__*/React.createElement("path", {
    d: "M-0.00082,13.20557v0v-13v0h13v0v13v0z",
    className: "bi-chevron-left-square",
    fill: "currentColor",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Icon ionic-md-arrow-round-forward"), /*#__PURE__*/React.createElement("path", {
    d: "M7.36458,11.39527v0l4.13535,-4.01258c0.17967,-0.17368 0.2695,-0.41024 0.2695,-0.67076v-0.01198c0,-0.26052 -0.08983,-0.49708 -0.2695,-0.67076l-4.13535,-4.01258c-0.35934,-0.37431 -0.93727,-0.37431 -1.29361,0c-0.35634,0.37431 -0.35634,0.97919 0,1.3535l2.4854,2.3776v0h-6.40815c-0.50906,0 -0.9193,0.42821 -0.9193,0.95823c0,0.539 0.41024,0.95823 0.91631,0.95823h6.40814v0l-2.4854,2.3776c-0.35634,0.37431 -0.35634,0.97919 0,1.3535c0.35933,0.37431 0.93727,0.37431 1.2966,0z",
    fill: "currentColor",
    className: "bi-chevron-left-arrow",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.455d05b2.svg";
export { ForwardRef as ReactComponent };